import React from "react";
import {t, Trans} from '@lingui/macro';
import {useLingui} from "@lingui/react";
import {Form, Input} from "antd";

// NOTE: Please use <PhoneNumberInputV2 /> if possible.
// When normalizing data to submit to backend, can refer to
// src/containers/Page/TransactionViewV3/components/RequestEInvoiceDrawer/index.js on how phone_no is parsed
export function PhoneNumberFormItem(props) {
    const {
        name,
        label,
        extra,
        initialValue,
        rules,
        required,
        useDefaultRequiredRule, // whether to use the default required rule message
    } = props;

    useLingui();

    return (
        <Form.Item
            name={name}
            label={label}
            extra={extra}
            rules={[
                ...rules,
                (required && useDefaultRequiredRule) ? {
                    required: true,
                    message: t`Please enter your mobile number.`,
                } : {},
            ]}
            initialValue={initialValue}
        >
            <Input
                addonBefore="+"
                type="number"
                placeholder={t`Eg. 60161234567`}
                allowClear
            />
        </Form.Item>
    );
}

PhoneNumberFormItem.defaultProps = {
    required: true,
    name: 'phone_no',
    label: <Trans>Mobile No.</Trans>,
    initialValue: "60",
    rules: [
        {
            min: 7,
            message: t`Mobile number is too short.`,
        }, {
            max: 15,
            message: t`Mobile number is too long.`,
        }],
    useDefaultRequiredRule: true,
};
